import { useEffect } from 'react'
import '../styles/components/Toast.css'

export type ToastType = 'success' | 'error' | 'info'

interface ToastProps {
  message: string
  type?: ToastType
  onClose: () => void
  duration?: number
}

export default function Toast({ message, type = 'info', onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration)
      return () => clearTimeout(timer)
    }
  }, [duration, onClose])

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite" aria-atomic="true">
      <span className="toast-message">{message}</span>
      <button onClick={onClose} className="toast-close" aria-label="Close notification">
        ×
      </button>
    </div>
  )
}
